import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Radio, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#D6D3D1] text-zinc-900 flex items-center justify-center px-5 grain">
      <div className="w-full max-w-sm animate-in fade-in slide-in-from-bottom-2 duration-500">
        <Link
          to="/"
          className="flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-zinc-600 hover:text-[#5EA529] mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Volver
        </Link>

        <div className="flex items-center gap-2.5 mb-8">
          <img src="/logo.png" alt="Radio Club" className="h-12 w-auto" />
          <span className="font-mono font-bold tracking-tighter text-2xl">Panel Admin</span>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-zinc-600">Email</Label>
            <Input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-white border-zinc-400 rounded-sm font-mono h-12 focus-visible:ring-[#5EA529]"
              placeholder="admin@ham.radio"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-zinc-600">Contraseña</Label>
            <Input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-white border-zinc-400 rounded-sm font-mono h-12 focus-visible:ring-[#5EA529]"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-red-400 text-sm font-mono">
              {error}
            </p>
          )}
          <Button
            type="submit"
            data-testid="login-submit-btn"
            disabled={loading}
            className="w-full bg-[#5EA529] hover:bg-[#4f8c22] text-white font-semibold rounded-sm h-12 transition-colors"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
